import Edit from './Edit'

export default Edit
// eslint-disable-next-line import/export
export * from './Edit'
